import { render, staticRenderFns } from "./ParkingPropertyIconItem.vue?vue&type=template&id=35a9ea9f&"
import script from "./ParkingPropertyIconItem.vue?vue&type=script&lang=js&"
export * from "./ParkingPropertyIconItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports